import React, { useState, useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { Box, Typography, CircularProgress, TextField } from "@mui/material";
import { apiVariable } from "../../../api/apiVariable";
import useAuth from "../../../hooks/useAuth";
import { saleTableColumns } from "../../../data/FormColumns/Fleet/saleTableColumns";
import PersistedDataGrid from "../../PersistedDataGrid/PersistedDataGrid";

const fetchSales = async (token: string | undefined | null) => {
  const { data } = await axios.get(`${apiVariable}/sales`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return data;
};

const SaleTable: React.FC = () => {
  const { token } = useAuth();

  const [searchTerm, setSearchTerm] = useState("");

  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["sales"],
    queryFn: () => fetchSales(token),
    enabled: !!token,
  });

  const filteredSales = useMemo(() => {
    if (!data) return [];
    return data.filter((sale: any) =>
      [sale.unitNumber, sale.saleStatus].some((field) =>
        field?.toString().toLowerCase().includes(searchTerm.toLowerCase()),
      ),
    );
  }, [data, searchTerm]);

  return (
    <Box className="incidents-table-container" height={900}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "flex-end",
        }}
      >
        <TextField
          label="Search"
          variant="outlined"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          placeholder="Search by Unit # or Status"
          sx={{ maxWidth: "100%", width: 400 }}
        />
      </Box>
      {isLoading ? (
        <Box display="flex" justifyContent="center" alignItems="center">
          <CircularProgress />
        </Box>
      ) : isError ? (
        <Typography color="error">Error: {(error as any).message}</Typography>
      ) : (
        <PersistedDataGrid
          tableName="sales"
          rows={filteredSales}
          columns={saleTableColumns}
          sx={{ height: 700 }}
        />
      )}
    </Box>
  );
};

export default SaleTable;
